const initialState = {
    data: null,
    error: null,
}
export const sendVerificationEmailRedux = (state = initialState, action) => {
    switch (action.type) {
        case 'RESENDEMAIL_SUCCESS':
            return {
                ...state,
                error: null,
                data: action.payload,
            };
        case 'RESENDEMAIL_FAILURE':
            return {
                ...state,
                error: action.payload
            };
        case 'RESENDEMAIL_RESET':
            return initialState;
        default:
            return state;
    }
}

export default sendVerificationEmailRedux;